import React, { useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';

const crumbs = [
  { label: 'Home', link: '/' },
  { label: 'About', link: '/about' },
  { label: 'Services', link: '/services' },
  { label: 'Get a Quote' },
];

const offices = [
  { city: 'Shipu Port, China', tag: 'Main Shipyard Infrastructure' },
  { city: 'Singapore', tag: 'Bunkering Operations Hub' },
  { city: 'Ningbo, China', tag: 'Technical Corporate Office' },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!form.name || !form.email || !form.service || !form.message) {
      setError('Please fill in all fields before submitting.');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      const response = await fetch('https://formspree.io/f/mqevqqjd', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      });

      if (response.ok) {
        setSubmitted(true);
        setForm({ name: '', email: '', service: '', message: '' });
      } else {
        const data = await response.json();
        setError(data.error || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      setError('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Get a Quote" crumbs={crumbs} />

      {/* Map */}
      <div>
        <iframe
          className="map-frame"
          title="East Star Marine Headquarters"
          src="https://maps.google.com/maps?q=shanghai+china&ie=UTF8&iwloc=&output=embed"
          scrolling="no"
        />
      </div>

      {/* Contact content */}
      <section className="section">
        <div className="container">
          <div className="contact-grid">
            {/* Left: Info */}
            <div>
              <div className="eyebrow"><i className="fas fa-comments"></i> Free Consultation</div>
              <h2 className="section-title">Elevate Your Maritime Fleet</h2>
              <p style={{ marginBottom: '32px' }}>Share your specific vessel parameters or refueling needs, and one of our marine engineering specialists will follow up with technical routing options and quotes within one business day.</p>

              <div className="contact-info-item">
                <div className="contact-info-icon"><i className="fas fa-map-marker-alt"></i></div>
                <div className="contact-info-text">
                  <h4>Shipyard Base</h4>
                  <p>Shanghai, China</p>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon"><i className="far fa-clock"></i></div>
                <div className="contact-info-text">
                  <h4>Support Hours</h4>
                  <p>Monday – Sunday, 24 Hours Fleet Coverage</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon"><i className="fas fa-phone-alt"></i></div>
                <div className="contact-info-text">
                  <h4>Get in Touch</h4>
                  <p><strong>+86 152 5809 2554</strong></p>
                  <a href="mailto:support@eaststarmarine.com">support@eaststarmarine.com</a>
                </div>
              </div>

              
            </div>

            {/* Right: Form */}
            <div className="contact-form-box">
              <h3>Request a Technical Consultation</h3>
              <p className="lead">We'll get back to you within 24 hours with engineering solutions, charter options, and configuration pricing.</p>
              {submitted ? (
                <div className="form-success">
                  <i className="fas fa-check-circle"></i>
                  Thank you! Your inquiry has been received. A maritime infrastructure specialist will contact you within 24 hours.
                </div>
              ) : (
                <form onSubmit={handleSubmit} noValidate>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Full Name / Corporate Representative</label>
                      <input id="name" type="text" name="name" placeholder="Jane Doe" value={form.name} onChange={handleChange} disabled={isSubmitting} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email Address</label>
                      <input id="email" type="email" name="email" placeholder="jane@company.com" value={form.email} onChange={handleChange} disabled={isSubmitting} />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="service">Maritime Service Needed</label>
                    <select id="service" name="service" value={form.service} onChange={handleChange} disabled={isSubmitting}>
                      <option value="">Select a service</option>
                      <option>Shipbuilding & Construction</option>
                      <option>Bunkering Operations (Rent / Sale)</option>
                      <option>Fleet Expansion & Sourcing</option>
                      <option>Maintenance, Dry Dock & Refurbishment</option>
                      <option>Crew Arrangement & Management</option>
                      <option>ISM Compliance & Quality Control</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Project or Fleet Details</label>
                    <textarea id="message" name="message" placeholder="Vessel specifications, deadweight tonnage metrics, target timeline, or bunkering capacities..." value={form.message} onChange={handleChange} disabled={isSubmitting} />
                  </div>
                  {error && (
                    <p className="form-error"><i className="fas fa-exclamation-circle"></i>{error}</p>
                  )}
                  <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
                    {isSubmitting ? 'Sending...' : 'Send Request'} 
                    {!isSubmitting && <i className="fas fa-paper-plane"></i>}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}